import { Typography } from '@mui/material';
import React from 'react';
import Calendar from '../../components/Contractors/Calendar/Calendar';

const ContractorCalendar = () => {
    return (
        <div>
            <Typography variant='h1'>Calendar</Typography>
            <Calendar />
        </div>
    );
};

export default ContractorCalendar;
